import { Typography } from '@mui/material';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { VideoRecorderIcon } from 'assets/svg';
import { Hotkey } from 'config/enums';
import styled from 'features/theme/styled';
import theme from 'features/theme/theme';
import { Button } from 'features/ui/elements';

interface TeamingRemoteCanceledBaseProps {
  onPrimaryButtonClick: () => void;
  onSecondaryButtonClick: () => void;
}

export const TeamingRemoteCanceledBase: FC<TeamingRemoteCanceledBaseProps> = ({
  onSecondaryButtonClick,
  onPrimaryButtonClick,
}) => {
  const { t: ct } = useTranslation();
  const { t } = useTranslation('translation', { keyPrefix: 'teamCanceled' });

  return (
    <Container>
      <Icon />
      <Typography
        variant='h1'
        align='center'
        color={theme.palette.common.white}
        mt={15}
      >
        {t('title')}
      </Typography>
      <ReadyForAnotherCallBtn
        fullWidth
        size='large'
        title={t('readyForAnotherCall')}
        onClick={onPrimaryButtonClick}
        hotkey={Hotkey.ReturnToQueue}
      >
        {t('readyForAnotherCall')}
      </ReadyForAnotherCallBtn>
      <LeaveQueueBtn
        fullWidth
        size='small'
        color='secondary'
        title={ct('leaveQueue')}
        onClick={onSecondaryButtonClick}
      >
        {ct('leaveQueue')}
      </LeaveQueueBtn>
    </Container>
  );
};

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 432px;
  padding: ${theme.spacing(23)};
  border-radius: 8px;
  background: ${theme.palette.grey[900]};
`;

const Icon = styled(VideoRecorderIcon)`
  margin-top: ${theme.spacing(7)};
`;

const ReadyForAnotherCallBtn = styled(Button)`
  margin-top: ${theme.spacing(16)};
`;

const LeaveQueueBtn = styled(Button)`
  margin-top: ${theme.spacing(8)};
`;
